import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { filter } from 'rxjs';
import { Product } from 'src/app/models/product.model';
import { CartService } from 'src/app/services/cart.service';
import { OrderService } from 'src/app/services/order.service';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.less']
})
export class OrderDetailComponent implements OnInit {
  itemList: any[] = [];
  orderNo: string = "";
  order: any = undefined;
  country: string | null = localStorage.getItem("country");
  constructor(private route: ActivatedRoute, private orderService: OrderService, private router: Router, private cartService: CartService, private message: NzMessageService, 
    private sharedData: SharedDataService,
    private translate: TranslateService) {
      this.sharedData.currentData.subscribe(data => {
        this.isDealerPortal = data.isDealerPortal;
      });
  }
  expandSet = new Set<string>();
  isVisible:boolean = false;
  cancelType:string|undefined;
  firstLoading:boolean = true;
  isDealerPortal: boolean = false;
  params:any;// cancel params
  onExpandChange(id: string, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }
  handleCancel():void{
    if(this.cancelType=='order'){
      this.cancelOrder(this.params);
    }else{
      this.cancelItem(this.params);
    }
  }

  opeCancelModal(cancelType:string, params:any):void{
    this.cancelType = cancelType;
    this.isVisible = true;
    this.params = params;
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo(0, 0);
    });
    this.translate.onLangChange.subscribe(() => {
      if(this.router.url.includes('/order/detail') && !this.firstLoading){
        this.initData();
      }
    });
    this.initData();
    this.firstLoading = false;
   

  }
  initData(){
    this.route.queryParams.subscribe(params => {
      this.orderNo = params['orderNo'];
      if (this.orderNo) {
        this.getOrderInfo(this.orderNo);
        this.getItemList(this.orderNo);
      }
      if (params['isOrderSuccess']) {
        localStorage.removeItem('isOrderDetailBack');
      } else {
        localStorage.setItem('isOrderDetailBack', 'true');
      }
    })
  }
  getItemList(orderNo: string) {
    let params = {
      orderNo: orderNo,
      size: 1000,
      current: 1,
      column: 'oi.order_create_date',
      order: 'desc'
    };
    this.orderService.queryItemData(params).subscribe((result: any) => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { records } = rtnData;
        this.itemList = records.map((item: any) => {
          return { ...item, visible: false };
        });
      }
    });
  }
  getOrderInfo(orderNo: string) {
    let params = {
      orderNo: orderNo,
      size: 10,
      current: 1,
    };
    this.orderService.queryOrderData(params).subscribe((result: any) => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { records, total } = rtnData;
        this.order = {...records[0], visible: false};
      }
    });
  }

  async orderAgain(list: any[]): Promise<void> {
    //go to cart
    let products: Product[] = list.map(item => {
      return {
        inputMaterialNumber: item.orderedMaterialNumber,
        expectedDate: item.scheduleConfirmedDeliveryDate,
        quantity: item.orderQuantity
      };
    })
    await this.cartService.addToCart(products).then(() => {
      this.router.navigateByUrl(`${this.country}/cart`);
    });
  }
  async cancelOrder(orderNo: string): Promise<void> {
    let params = {
      salesOrderNo: orderNo
    };
    await this.orderService.cancelOrder(params).subscribe((result) => {
      this.isVisible = false;
      if (result.rtnData.result) {
        this.message.create(
          'success',
          this.translate.instant('OPERATION_SUCCESS')
        );
        this.getOrderInfo(this.orderNo);
        this.getItemList(this.orderNo);
      } else {
        if (result.rtnData.errorMessage.length > 0) {
          this.message.create(
            'error',
            result.rtnData.errorMessage[0].message
          );
        } else {
          this.message.create(
            'error',
            this.translate.instant('OPERATION_FAILED')
          );
        }

      }
    });
  }

  async cancelItem(item: any): Promise<void> {
    let params = {
      cancelItems: [
        {
          itemNo: item.itemNo,
          productId: item.orderedMaterialNumber
        },
      ],
      salesOrderNo: item.orderNo
    };
    await this.orderService.cancelItem(params).subscribe((result) => {
      this.isVisible = false;
      if (result.rtnData.result) {
        this.message.create(
          'success',
          this.translate.instant('OPERATION_SUCCESS')
        );
        this.getOrderInfo(this.orderNo);
        this.getItemList(this.orderNo);
      } else {
        if (result.rtnData.errorMessage.length > 0) {
          this.message.create(
            'error',
            result.rtnData.errorMessage[0].message
          );
        } else {
          this.message.create(
            'error',
            this.translate.instant('OPERATION_FAILED')
          );
        }
      }
    });;
  }
  getPercent(completed: string, total: string): number {
    return (parseInt(completed) / parseInt(total)) * 100;
  }
  getColor(status: string): string {
    let color = "";
    switch (status) {
      case "Being Processed":
        color = "#F19F23";
        break;
      case "Open":
        color = "#9E2896";
        break;
      case "Completed":
        color = "#18837E";
        break;
      default:
        color = "#A0A0A0";
        break;
    }
    return color;
  }
  getColorByStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    switch (status) {
      case "Being Processed":
        color = isBackground ? "#FEF5E9" : (isBorder ? "#F6C172" : "#F19F23");
        break;
      case "Open":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "Completed":
        color = isBackground ? "#F1F8F7" : (isBorder ? "#84BDBA" : "#18837E");
        break;
      default:
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
    }
    return color;
  }
  canCancel(date: string): boolean {
    let targetTime = new Date(date);
    targetTime.setHours(new Date(date).getHours() + 1);
    return new Date() <= targetTime;
  }

  // 物流号跳转
   goTracking(trackingNo:string):void{
      if (trackingNo.startsWith('SF')) {
        return;
      }
      const urlSuffix = `/l/bo_order_tracing_ext?no=${trackingNo}`;
      
      const targetUrl = environment.production
        ? `https://bosch.my.logwirecloud.com/#${urlSuffix}` // production
        : `https://nnbn--dev3-lz.dev3.logwirecloud.com/#${urlSuffix}`; // stage
  
      window.open(targetUrl, '_blank');
    }
}
